<template>
	<div>
		<!-- Modal -->
		<div
			v-if="show"
			class="modal-mask">
			<div class="modal-wrapper">
				<div
					class="modal fade in show"
					role="dialog"
					style="display: block;">
					<div
						class="modal-dialog"
						:class="`modal-${size}`">
						<div class="modal-content">
							<div class="modal-header">
								<h4 class="modal-title float-left">
									{{ title }}
								</h4>
								<slot
									name="toolbar"
									class="float-right"></slot>
								<button
									type="button"
									class="close float-right"
									:disabled="disableClose"
									@click="close">
									&times;
								</button>
							</div>
							<div class="modal-body">
								<slot name="body"></slot>
							</div>
							<div class="modal-footer">
								<button
									class="btn btn-default btn-md"
									:disabled="disableClose"
									@click="close">
									Close
								</button>
								<slot name="footer"></slot>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			title: {
				type: String,
				default: null,
			},
			disableClose: {
				type: Boolean,
				required: false,
				default: false,
			},
			size: {
				type: String,
				default: 'lg'
			}
		},
		emits: ['close'],
		data() {
			return {
				show: false
			}
		},
		watch: {
			//
		},
		created() {
			//
		},
		mounted() {
			//
		},
		methods: {
			open: function () {
				this.show = true;
				const el  = document.body;
				el.classList.add('modal-open');
			},
			close: function () {
				this.$emit('close');
				const el = document.body;
				el.classList.remove('modal-open');
				this.show = false;
			}
		}
	}
</script>

<style scoped>
	.popover {
		z-index: 99999;
	}

	.show {
		display: block;
		transition: opacity .15s linear;
	}

	.modal {
		text-align: center;
	}

	.modal-mask {
		position: fixed;
		z-index: 2100;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .5);
		display: table;
		transition: opacity .3s ease;
	}

	.modal-body {
		padding-bottom: 20px;
	}

	.modal-wrapper {
		display: table-cell;
	}

	@media screen and (min-width: 768px) {
		.modal:before {
			content: " ";
			height: 100%;
		}
	}

	.modal-dialog {
		text-align: left;
		vertical-align: top;
	}
</style>
